export const markerAction = (payload) => ({
  type: 'MARKER_CENTER',
  payload: payload
})

export const removeCenterMarker = () => ({
  type: 'MARKER_CENTER_REMOVE',
  payload: null
})
